import React, { useContext } from 'react';
import { BookOutlined, UserOutlined } from '@ant-design/icons';
import Popover from '../Popover';
import IconNewCalendar from '../Icons/IconNewCalendar';
import { ConfigContext } from '../../context/Config';
import Avatar from '../Avatar';
import Text from '../Text';
import withSkeleton from '../../hoc/withSkeleton';
import CourseDetailSkeleton from './CourseDetailSkeleton';
import CourseCoverDefaultImg from '../../images/course-cover-default.svg';
import CourseDefaultImg from '../../images/course-default.png';
import Wrapper from '../Wrapper';
import './CourseDetail.less';
import ImageCard from '../ImageCard';

type CourseDetailProps = {
  title: string;
  image?: string;
  coverImage?: string;
  lessonCount: number;
  description?: string;
  coverHeight?: string;
  teachers?: Array<{
    fullName: string;
  }>;
  renderTeachers?: (teachers) => {};
  renderSchedule?: () => {};
  renderAction?: () => {};
  lessonType: string;
  price: string;
};

const CourseDetail: React.FC<CourseDetailProps> = ({
  title = '',
  image = '',
  lessonCount,
  coverHeight = '300px',
  coverImage = '',
  teachers = [],
  lessonType,
  renderTeachers,
  renderSchedule,
  renderAction,
  price,
}) => {
  const { translate } = useContext(ConfigContext);

  return (
    <div className="course-detail-container">
      <ImageCard
        coverHeight={coverHeight}
        cover={
          <div className="course-detail-cover-photo">
            <img
              src={coverImage ? coverImage : CourseCoverDefaultImg}
              style={{
                height: coverHeight,
                objectFit: 'cover',
                width: '100%',
              }}
            />
          </div>
        }
      >
        <div className="course-detail-wrapper">
          <div className="course-detail-info">
            <div className="course-detail-image">
              <img src={image || CourseDefaultImg} />
              {!!renderSchedule && (
                <div className="schedule-viewer">
                  <div className="schedule-viewer-icon">
                    <span className="icon-calendar">
                      <Popover
                        placement="topRight"
                        trigger="click"
                        content={renderSchedule}
                      >
                        <IconNewCalendar size="md" />
                      </Popover>
                    </span>
                  </div>
                </div>
              )}
            </div>
            <Wrapper
              ml={2}
              mt={2}
              mb={2}
              display="flex"
              flexDirecton="column"
              justifyContent="space-between"
              style={{ flex: 1 }}
            >
              <Wrapper mb={2}>
                <Text rows={2} bold level={1}>
                  {title}
                </Text>
              </Wrapper>
              <Wrapper>
                {teachers.length === 1 && !renderTeachers && (
                  <div className="icon-with-text">
                    <Avatar
                      src={''}
                      name={teachers[0]?.fullName || ''}
                      size="xxs"
                    />
                    <div>{teachers[0]?.fullName}</div>
                  </div>
                )}
                {teachers.length > 1 && !renderTeachers && (
                  <div className="detail-info-item">
                    <UserOutlined />
                    <div>{translate('Multiple teachers')}</div>
                  </div>
                )}
                {!!renderTeachers && renderTeachers(teachers)}
                {!!lessonCount && (
                  <div className="detail-info-item">
                    <BookOutlined />
                    {lessonCount} {translate('Lessons')}
                  </div>
                )}
                {!!lessonType && (
                  <div className="detail-info-item">
                    <UserOutlined />
                    {translate(lessonType)}
                  </div>
                )}
              </Wrapper>
            </Wrapper>
          </div>
          <Wrapper display="flex" flexDirecton="column" alignItems="end">
            <div className="course-price">
              <Text level={1}>{price}</Text>
            </div>
            <div className="action-container">
              {!!renderAction && renderAction()}
            </div>
          </Wrapper>
        </div>
      </ImageCard>
    </div>
  );
};

export default withSkeleton(CourseDetail, CourseDetailSkeleton);
